import { apiClient } from './apiClient';
import type { AuthStatus } from '../types';

interface UnlockResponse {
  message: string;
  role: 'browser' | 'admin';
}

interface StatusResponse {
  is_admin: boolean;
  role: 'browser' | 'admin';
}

export const authApi = {
  async unlock(passcode: string): Promise<AuthStatus> {
    const response = await apiClient.post<UnlockResponse>('/api/auth/unlock', { passcode });
    // Transform backend response to frontend AuthStatus
    return {
      authenticated: response.data.role === 'admin',
      role: response.data.role,
    };
  },

  async lock(): Promise<{ message: string }> {
    const response = await apiClient.post('/api/auth/lock');
    return response.data;
  },

  async getStatus(): Promise<AuthStatus> {
    const response = await apiClient.get<StatusResponse>('/api/auth/status');
    // Transform backend response to frontend AuthStatus
    return {
      authenticated: response.data.is_admin,
      role: response.data.role,
    };
  },
};
